import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Sarah', 'María', 'Laura', 'Carmen', 'Ana', 'Patricia', 'Elena', 'Sofía', 'Isabel', 'Lucía', 'Marta', 'Rosa', 'Claudia', 'Diana', 'Valentina', 'Gabriela', 'Andrea', 'Paula', 'Natalia', 'Carolina'];
const cities = ['Miami', 'Los Angeles', 'Houston', 'Chicago', 'Nueva York', 'San Antonio', 'Dallas', 'Phoenix', 'San Diego', 'Orlando', 'Tampa', 'Denver', 'Las Vegas', 'Atlanta', 'Austin', 'San Jose', 'El Paso', 'Albuquerque', 'Tucson', 'Sacramento'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  const showNotification = useCallback(() => {
    setData({
      name: getRandomItem(names),
      city: getRandomItem(cities)
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 3000);
  }, []);
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 4000);
    // Then loop: 3s visible + 5s hidden = 8s cycle
    const interval = setInterval(() => {
      showNotification();
    }, 8000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <div className="block md:hidden" data-id="element-202">
      <AnimatePresence data-id="element-203">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 60,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25,
        mass: 0.8
      }} className="fixed bottom-6 left-4 right-4 z-50 mx-auto max-w-sm" data-id="element-204">
            <div className="flex items-center gap-3 rounded-2xl px-4 py-3 shadow-lg border border-white/40" style={{
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)'
        }} data-id="element-205">
              <img src="https://cdn.magicpatterns.com/uploads/v1ywhK3xGFPR71JBCTig2y/Imagen_Producto.png" alt="Paz Hormonal" className="w-11 h-11 rounded-xl object-cover flex-shrink-0" data-id="element-206" />
              <div className="flex-1 min-w-0" data-id="element-207">
                <p className="text-xs text-gray-500 leading-tight" data-id="element-208">
                  Hace un momento
                </p>
                <p className="text-sm text-gray-900 leading-snug mt-0.5" data-id="element-209">
                  <span className="font-semibold" data-id="element-210">{data.name}</span>
                  {' de '}
                  <span data-id="element-211">{data.city}</span>
                  {' compró '}
                  <span className="font-semibold italic" data-id="element-212">Paz Hormonal</span>
                  {' por '}
                  <span className="font-bold text-brand-green" data-id="element-213">$37</span>
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}